import { useEffect, useState } from "react";

export type Theme = "light" | "dark" | "system";

const STORAGE_KEY = "theme";
const CYCLE: Theme[] = ["system", "dark", "light"];

function applyTheme(theme: Theme) {
	const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
	const isDark = theme === "dark" || (theme !== "light" && prefersDark);
	document.documentElement.classList.toggle("dark", isDark);
}

export function useTheme() {
	const [theme, setThemeState] = useState<Theme>("system");

	useEffect(() => {
		try {
			const stored = localStorage.getItem(STORAGE_KEY) as Theme;
			if (stored && CYCLE.includes(stored)) setThemeState(stored);
		} catch {}
	}, []);

	useEffect(() => {
		applyTheme(theme);
		try {
			localStorage.setItem(STORAGE_KEY, theme);
		} catch {}

		if (theme === "system") {
			const mq = window.matchMedia("(prefers-color-scheme: dark)");
			const handler = () => applyTheme("system");
			mq.addEventListener("change", handler);
			return () => mq.removeEventListener("change", handler);
		}
	}, [theme]);

	function cycleTheme() {
		setThemeState((t) => CYCLE[(CYCLE.indexOf(t) + 1) % CYCLE.length]);
	}

	return { theme, setTheme: setThemeState, cycleTheme };
}
